import { Component, Inject, OnInit, OnDestroy, AfterViewInit } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { Subject } from 'rxjs';

import { User } from '@model/authentication.model';

import { AuthenticationService } from '@service/authentication.service';
import { Logger } from '@service/logger.service';
import { Router } from '@angular/router';
import { IPostMessageEventTarget, PostMessageBridgeFactory } from './postmessage';

const log: Logger = new Logger('Policy');

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html'
})
export class AppComponent implements OnInit, OnDestroy {
  initialized = false;

  private onDestroy$: Subject<void> = new Subject();

  constructor(
    private authenticationService: AuthenticationService,
    private translateService: TranslateService,
    private router: Router,
    @Inject(PostMessageBridgeFactory) private bridgeFactory: PostMessageBridgeFactory
  ) {}

  ngOnInit(): void {
    if (window.parent.length === 0) {
      this.initialized = true;
    } else {
      this.postMessage();
    }
    this.initTranslation();
  }

  ngOnDestroy(): void {
    this.onDestroy$.next();
    this.onDestroy$.complete();
  }

  initTranslation(): void {
    const storageLang: string = this.authenticationService.getLanguage();
    if (storageLang) {
      this.translateService.use(storageLang);
    } else {
      this.translateService.use('th');
    }
  }

  showFooter(): boolean {
    return this.router.url.includes('search');
  }

  private postMessage(): void {
    // const parentWindow: IPostMessageEventTarget = window.top;
    const parentWindow: IPostMessageEventTarget = window.parent;
    const currentWindow: IPostMessageEventTarget = window;

    this.bridgeFactory
      .makeInstance()
      .setEnableLogging(true)
      .connect(currentWindow, parentWindow)
      .makeBridge('ChildInit')
      .makeBridge('ChangeLanguage')
      .makeBridge('Token')
      .makeBridge('Unauthorized')
      .addListener('Token', (user: User) => {
        log.debug('Got credentials');
        this.authenticationService.sendUserMessage(user).then(() => {
          this.initialized = true;
        });
      })
      .addListener('ChangeLanguage', (language: string) => {
        log.debug('Changed Language');
        this.translateService.use(language);
      })
      .sendMessage('ChildInit', 'policy');
  }
}
